import ProgressBar from "../molecules/ProgressBar";

export default function MeasurementInfo({icn, name, data}) {
    let badgeColor = "";
    switch (data.itemBadge) {
        case "유지":
        case "양호":
            badgeColor = "blue";
            break;
        case "나쁨":
            badgeColor = "red";
            break;
        case "조금 나쁨":
            badgeColor = "orange";
            break;
        case "일반":
            badgeColor = "yellow";
            break;
        case "주의":
            badgeColor = "red";
            break;
        case "관심":
            badgeColor = "purple";
            break;
    }
    return (
        <section>
            <div className="icn-title">
                <img className="icon" src={icn} />
                <div className="h3">
                    {name} 
                    <span className={"report-badge " + badgeColor}>{data.itemBadge}</span>
                </div>
            </div>

            <div className="data-wrap type-01">
                <div className="left">
                    <div className="score-wrap">
                        점수
                        <div className="score">
                            <span>{data.score}</span>점
                        </div>
                    </div>
                    <ProgressBar value={data.score}/>
                </div>

                <div className="right">
                    <div className="result">
                        분석결과
                        
                        <div className="report-badge">
                            {
                                data.analysisBadge
                            }
                        </div>
                    </div>
                    <p className="body2">{data.analysisResult1}</p>
                    {
                    data.percentage != undefined &&
                    <small>점유 비율 면적: {data.percentage}%</small>
                    }
                </div>
            </div>
        </section>
    )
}